import { ConfirmDialog } from '@platform/design-system';
import { usePageContext } from '../../usePageContext.ts';
import { NameViewDialog } from './NameViewDialog.tsx';
import type { DashboardView } from './widget-types.ts';

export type Naming = { readonly mode: 'saveAs' } | { readonly mode: 'rename'; readonly view: DashboardView };

export type DashboardDialogsProps = {
  naming: Naming | null;
  deleting: DashboardView | null;
  onName: (naming: Naming, name: string) => void;
  onCloseNaming: () => void;
  onConfirmDelete: (view: DashboardView) => void;
  onCloseDelete: () => void;
};

export const DashboardDialogs = ({
  naming,
  deleting,
  onName,
  onCloseNaming,
  onConfirmDelete,
  onCloseDelete,
}: DashboardDialogsProps) => {
  const { t } = usePageContext();
  return (
    <>
      {naming === null ? null : (
        <NameViewDialog
          title={t(naming.mode === 'rename' ? 'dashboard.views.renameTitle' : 'dashboard.views.saveAsTitle')}
          initialName={naming.mode === 'rename' ? naming.view.name : ''}
          onClose={onCloseNaming}
          onSubmit={(name) => {
            onName(naming, name);
          }}
        />
      )}
      {deleting === null ? null : (
        <ConfirmDialog
          title={t('dashboard.views.deleteTitle')}
          message={t('dashboard.views.deleteMessage', { name: deleting.name })}
          confirmLabel={t('dashboard.views.delete')}
          cancelLabel={t('common.cancel')}
          closeLabel={t('common.close')}
          onConfirm={() => {
            onConfirmDelete(deleting);
          }}
          onCancel={onCloseDelete}
        />
      )}
    </>
  );
};
